import { render } from "./QuestionsModule.html?vue&type=template&id=800be0b4&scoped=true&external"
import script from "./QuestionsModule.vue?vue&type=script&lang=js"
export * from "./QuestionsModule.vue?vue&type=script&lang=js"

import "./QuestionsModule.vue?vue&type=style&index=0&id=800be0b4&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-800be0b4"]])

export default __exports__